export const getDefaultAutoHideDuration = (
  severity?: 'info' | 'warning' | 'error' | 'success',
): number => {
  switch (severity) {
    case 'success':
      return 2000;
    case 'error':
      return 5000;
    default:
      return 2000;
  }
};
